<div class="custom-dropdown-bottom">
    <mat-nav-list disableRipple fxLayout="column" >
        <a mat-list-item *ngFor="let item of model.items" [ngClass]="{'active': model.selectedItem == item}">
            <div class="label" (click)="changeItem(item, 'transactions')" fxLayout="row" fxFlex="100" fxLayoutAlign="start center">
                <div class="thumb" [ngStyle]="{'background-color':  model.selectedItem?.color ? model.selectedItem?.color : '#000'}" fxLayoutAlign="center center">{{item[model.display].charAt(0)}}</div>
                <div class="description" fxLayoutAlign="start center" fxFlex="100">{{item[model.display]}}</div>
            </div>
            <div class="icon" fxFlex="auto" fxLayoutAlign="center center" (click)="changeItem(item, 'settings')">
                <mat-icon svgIcon="icon_gear" class="icon-gear ic-svg-6"></mat-icon>
            </div>
        </a>
        
    </mat-nav-list>
</div>